// Dependencies
import Backbone from 'backbone';
import Handlebars, { log } from 'handlebars';
import EventHub from '~/eventHub';
import getUtilsService from "~/services/common/utilsService";
import Settings from '~/settings.js';

// Handlebars
import footerdacorwebappstemplate from "~/templates/common/footerdacorwebapps.handlebars";
import footeramericawebappstemplate from "~/templates/common/footeramericawebapps.handlebars";

Handlebars.registerHelper("inc", function(value, options){
    return parseInt(value) + 1;
});

var FooterView = Backbone.View.extend({
    className: 'footerView',
    initialize: function() {
      
    },
    events: {

    },
    translate: function(e){
      var that = this;
  		var callback = data => {
        if(arrlang[lang] === undefined){ return }
  			that.$el.find('.item').each(function(index, element){
  				$(this).text(arrlang[lang][$(this).attr("key")]);
  			});
  		}

  		if(Object.keys(window.arrlang).length !== 0){
  			callback();
  		}
  		this.listenTo(EventHub, 'translation', callback);
    },

    render: function() {
      if(typeof cordova === 'undefined' && Settings.footer && Settings.footer.active){
        var handlebars
        if(Settings.footer.dacor){
          handlebars = Handlebars.template(footerdacorwebappstemplate);  
        } else {
          handlebars = Handlebars.template(footeramericawebappstemplate);
        }   
        this.$el.html(handlebars({links: Settings.footer.links}));
        this.translate();
      }
      return this;
    },

});
export default FooterView;
